import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom';
import { all_routes } from '../../../router/all_routes'


interface BannerProps {
    apiValues: any;
    // miniBannerValues: any[];
}

const Benefits: React.FC<BannerProps> = ({ apiValues }) => {
    const route = all_routes;


    return (
        <>
            {/* benefits */}
            <section className="benefit-section bg-[#E7E7E7] ">
                <div className="container">
                    <div className="section-header text-start">
                        <span className="fw-medium text-secondary mb-2 d-inline-block">
                            {apiValues?.title || "One stop solution"}
                        </span>
                        <h2 className='text-[#1D1753]'>
                            {apiValues?.description || "Our Services"}
                        </h2>
                        <p className='text-[#1D1753]'>
                            {apiValues?.miniDescription || "We offer a comprehensive range of services to support your study abroad journey."}
                        </p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {
                            (Array.isArray(apiValues?.ourServicesCards) ? apiValues?.ourServicesCards : []).map((item: any, index: number) => (
                                <div key={index} className="flex">
                                    <div className="relative card newGradient bg-white rounded-3xl border border-transparent hover:border-primary transition-all duration-300 group flex flex-col p-4 h-full">
                                        <div className="px-4 rounded-full d-inline-flex mb-2">
                                            <ImageWithBasePath
                                                source={item?.iconUrl}
                                                style={{ height: 40, width: 40 }}
                                                className="rounded-full"
                                                alt="Img"
                                            />
                                        </div>
                                        <h5 className="text-[#1D1753] mt-1 mb-1 font-bold text-lg group-hover:text-primary transition-colors">
                                            {item.title}
                                        </h5>
                                        <p className="text-[#1D1753] flex-grow text-justify">
                                            {item.description}
                                        </p>
                                        <Link to={`${route.learnMore}/${item._id}`} className="mt-auto">
                                            <button className="learn-more-btn">
                                                <span className="btn-text">{item.buttonText}</span>
                                                <span className="btn-arrow">→</span>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                </div>
            </section>
        </>

    )
}

export default Benefits
